import { Currency } from './types/Currencies';
import { MakeCall } from './createMakeCall';
import { Listing } from './types/Listing';

export interface Query {
  bookablePeriods?: Listing['bookablePeriods'];
  currency?: Currency;
  /**
   * @description comma-separated string with possible values: `exclusions`, `exclusionsExtended`, `bookablePeriods`, `conversationCounters`, `lastMonthConversationCount`, `videos`, `costs`
   */
  expand?: string;
  lang?: string;
  from?: string;
  limit?: number;
  maxPrice?: number;
  minPrice?: number;
  offset?: number;
  orderBy?: string;
  query?: string;
  to?: string;
  userId: number;
  ids?: string;
  uuids?: string;
  withListingState?: string;
  withCharitable?: boolean;
  currencies?: string;
}

export interface ListingsResponse {
  count: number;
  listings: Listing[];
}

const getListings = (makeCall: MakeCall) => (query: Query) =>
  makeCall<ListingsResponse>('GET', `/api/v2/listings`, { query });
export { getListings };
